import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import EyeTableIcon from "../../public/assets/icons/EyeTableIcon";
import thumb1 from "../../public/assets/images/tab_thumbnail_1.jpg";
import thumb2 from "../../public/assets/images/tab_thumbnail_2.jpg";
import thumb3 from "../../public/assets/images/tab_thumbnail_3.jpg";
import thumb4 from "../../public/assets/images/tab_thumbnail_4.jpg";
import thumb5 from "../../public/assets/images/tab_thumbnail_5.jpg";
import thumb6 from "../../public/assets/images/tab_thumbnail_6.jpg";
import thumb7 from "../../public/assets/images/tab_thumbnail_7.jpg";
import thumb8 from "../../public/assets/images/tab_thumbnail_8.jpg";
import thumb9 from "../../public/assets/images/tab_thumbnail_9.jpg";
import thumb10 from "../../public/assets/images/tab_thumbnail_10.jpg";
import thumb11 from "../../public/assets/images/tab_thumbnail_11.jpg";
import thumb12 from "../../public/assets/images/tab_thumbnail_12.jpg";
import thumb13 from "../../public/assets/images/tab_thumbnail_13.jpg";
import thumb14 from "../../public/assets/images/tab_thumbnail_14.jpg";
import thumb15 from "../../public/assets/images/tab_thumbnail_15.jpg";
import thumb16 from "../../public/assets/images/tab_thumbnail_16.jpg";
import thumb17 from "../../public/assets/images/tab_thumbnail_17.jpg";
import thumb18 from "../../public/assets/images/tab_thumbnail_18.jpg";
import thumb19 from "../../public/assets/images/tab_thumbnail_19.jpg";
import thumb20 from "../../public/assets/images/tab_thumbnail_20.jpg";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import React from "react";
import styles from "../../styles/components/MemberPartnerDashboard/member-partner-duplicate-videos.module.scss";
import EmptyTable from "../EmptyTable/EmptyTable";
import NoResultTable from "../NoResultTable/NoResultTable";
import ApiLoader from "../Loaders/ApiLoader";
import iconOops from "../../public/assets/images/icon-oops.svg";
import {
  concatHostAndImagePath,
  getUtcDate,
} from "../../lib/functions/utils.lib";
import { usePost } from "../../hooks/api/useFetch";
import Pagination from "../UtilitiesComponent/Pagination";

function createData(
  vsid,
  acquisitor,
  thumbnail,
  title,
  submitter,
  email,
  submission,
  verification,
  viewBy
) {
  return {
    vsid,
    acquisitor,
    thumbnail,
    title,
    submitter,
    email,
    submission,
    verification,
    viewBy,
  };
}

const MemberPartnerDuplicateVideosTable = ({
  calenderDate,
  dateFilter,
  handlePageChange,
  page,
  setDuplicateTotal,
}) => {
  // duplicate video
  const {
    data: duplicateVideo,
    isSuccess: duplicateVideoIsSuccess,
    isLoading: duplicateVideoIsLoading,
    isError: duplicateVideoIsError,
    refetch: duplicateVideoRefetch,
  } = usePost(
    [
      "member_partner_duplicateVideos",
      // buyerId,
      // filterParams,
      calenderDate,
      dateFilter,
      // videoCountry,
      page,
    ],
    "member_partner/videos",
    {
      status: 6,
      type: "duplicate",
      from: dateFilter?.from ? dateFilter?.from : calenderDate?.from,
      to: dateFilter?.to ? dateFilter?.to : calenderDate?.to,
      page: page,
    }
  );

  setDuplicateTotal(duplicateVideo?.data?.total);

  console.warn("pendingVideo", duplicateVideo?.data?.data);
  // duplicate video
  return (
    <TableContainer className={styles.tableMain}>
      <ApiLoader loading={duplicateVideoIsLoading} />

      <PerfectScrollbar className={styles.custom_scroll}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className={styles.vsid}>VSID</TableCell>
              {/* <TableCell className={styles.acqui}>Acquisitor</TableCell> */}
              <TableCell className={styles.thumb}>Thumbnail</TableCell>
              <TableCell className={styles.title}>title</TableCell>
              <TableCell className={styles.submitter}>Submitter Name</TableCell>
              <TableCell className={styles.email}>Email Address</TableCell>
              <TableCell className={styles.youtube}>Submission Date</TableCell>
              <TableCell className={styles.publish}>Flagged On</TableCell>
              <TableCell className={styles.view} align="center">
                View
              </TableCell>
            </TableRow>
          </TableHead>

          {duplicateVideoIsLoading && !duplicateVideoIsSuccess ? (
            ""
          ) : duplicateVideo?.data?.data?.length ? (
            <TableBody>
              {duplicateVideo?.data?.data?.map((item, index) => (
                <>
                  <TableRow key={index} className={styles.tableActive}>
                    <TableCell>
                      <Box className={styles.vsidBox}>{item?.vsid}</Box>
                    </TableCell>

                    <TableCell>
                      <Box className={styles.thumbImg}>
                        {" "}
                        <img
                          src={concatHostAndImagePath(item?.thumbnail)}
                          width={73}
                          height={46}
                          alt="image"
                          className={styles.thumImg}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.titleBox}>{item?.title}</Box>
                    </TableCell>
                    <TableCell>
                      {item?.first_name}{" "}
                      {item?.last_name ? item?.last_name : "_"}
                    </TableCell>
                    <TableCell>
                      <Box className={styles.emailBox}>{item?.email}</Box>
                    </TableCell>
                    <TableCell>{getUtcDate(item?.created_at)}</TableCell>
                    <TableCell>
                      {" "}
                      {(item?.status === 6) === true ? (
                        <>{getUtcDate(item?.status_changed_at)} </>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Box className={styles.viewIcon}>
                        <Button>
                          <EyeTableIcon />
                        </Button>
                      </Box>
                    </TableCell>
                    {item?.viewBy === true ? (
                      <>
                        <TableCell className={styles.tdOverlay}>
                          <p>
                            This approved video is currently being verified by a
                            QC Agent.
                          </p>
                        </TableCell>
                      </>
                    ) : null}
                  </TableRow>
                  <TableRow className={styles.blnkTd}>
                    <TableCell colSpan={9}>{""}</TableCell>
                  </TableRow>
                </>
              ))}

              {/* No data found */}
              {duplicateVideo?.data?.data?.length &&
              duplicateVideo?.data.current_page &&
              duplicateVideo?.data.last_page ? (
                duplicateVideo?.data.current_page ===
                duplicateVideo?.data.last_page ? (
                  <TableRow
                    className={`${styles.endOfList} ${styles.nonHover}`}
                  >
                    <TableCell colSpan={9}>
                      <Typography variant="body1">
                        End of list. We couldn't find more flagged duplications
                        within the specified date range.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              <TableRow
                className={`${styles.paginationTble} ${styles.nonHover}`}
              >
                <TableCell colSpan={9} sx={{ border: "none !important" }}>
                  {duplicateVideo?.data?.data?.length ? (
                    <Pagination
                      page={duplicateVideo?.data?.current_page}
                      lastpage={duplicateVideo?.data?.last_page}
                      onClick={handlePageChange}
                      sendDataToParent={handlePageChange}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          ) : calenderDate.from || calenderDate.to ? (
            <TableBody>
              <TableRow>
                <TableCell
                  className={`${styles.emptyDataItem} ${styles.dateRangeNoresult} ${styles.nonHover}`}
                  colSpan={8}
                >
                  <Box className={styles.noFilter}>
                    <figure>
                      <img src={iconOops} width={36} height={41} alt="icon" />
                    </figure>
                    <Typography variant="body1">
                      We couldn't find any submitted videos within the specified
                      date range.
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell
                  className={`${styles.emptyDataItem} ${styles.nonHover}`}
                  colSpan={8}
                >
                  <Box className={styles.noFilter}>
                    <figure>
                      <img
                        src={roundRing}
                        width={207}
                        height={210}
                        alt="icon"
                      />
                    </figure>
                    <Typography
                      variant="body1"
                      sx={{
                        lineHeight: "25px !important",
                      }}
                    >
                      All is clear! No pending submissions found. <br />
                      Please refresh the page or check again later.
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
        {/* <EmptyTable emptyTableText={['All is clear! No flagged videos found.','Please refresh the page or check again later.' ] }/> */}

        {/* <NoResultTable errText={"We couldn't find any flagged videos within the specified date range."}/> */}

        {/* <TablePagination/> */}
      </PerfectScrollbar>
    </TableContainer>
  );
};

export default MemberPartnerDuplicateVideosTable;
